<template>
    <div>
        <el-form :inline="true" ref="form">

            <real-time-query-template :query-temp="query" :type="1" ref="realTimeQueryRef"/>

            <el-button type="primary" @click="onSubmit" size="mini" style="margin-top: 5px">查询</el-button>
<!--            <el-button type="success" size="mini" @click="exportFunc()">导出</el-button>-->
<!--            <el-button type="success" size="mini" @click="autoOptimize">Acos优化</el-button>-->

        </el-form>
        <el-table v-loading="loading" :data="list" :height="tableHeight" size="mini" ref="multipleTable"
                  @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                  class="table_content mini_div" border @sort-change="handleSortChange" style="width: 100%;">
            <el-table-column label="ID" width="60" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.img_url">
                        <img style="width:90px;height:90px;" src="@/assets/image/noPic.png"/>
                    </div>
                    <img style="width:90px;height:90px;" :src="scope.row.img_url" v-else/>
                </template>
            </el-table-column>

            <table-asin-column></table-asin-column>

            <el-table-column width="110" align="center" label="父asin">
                <template slot-scope="scope">
                    <span>{{ scope.row.parent_asin }}</span>
                </template>
            </el-table-column>

            <el-table-column label="负责人" width="100" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.username   }} <br/>
                        {{ scope.row.fullname }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column width="200" align="center" label="品名">
                <template slot-scope="scope">
                    <span>品名: {{ scope.row.product_name }}</span>
                    <div>
                        主卖色: {{ scope.row.is_main_seller == 1 ? '是' : scope.row.is_main_seller == 0 ? '否' : '未核对' }} <br/>
                        首单日期: {{ scope.row.first_order_time || '-' }} <br/>
                    </div>
                </template>
            </el-table-column>


            <el-table-column label="备注" align="center" :show-overflow-tooltip="true" width="220">
                <template slot-scope="scope">
                    <span>{{ scope.row.remark }}</span>
                </template>
            </el-table-column>

            <el-table-column label="FBA库存" width="200" align="center" class="zoom">
                <template slot-scope="scope">
                    <div @click="showFbaModal(scope.row.fba_datas || [])">
                        可售：{{ scope.row.fba_sale_quantity }} <br/>
                        {{ scope.row.maxSale }} <br/>
                        在途：{{ scope.row.fba_transit_quantity }} <br/>
                        {{ scope.row.maxTransit }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="核对信息" width="400" align="center">
                <template slot-scope="scope">
                    <div style="text-align: left">
                        <div style="font-size: 16px; font-weight: 600;">{{ scope.row.title }}</div>
                        <div style="display: flex" v-show="scope.row.rating">
                            <el-rate
                                v-model="scope.row.ratingNum"
                                disabled
                                text-color="#ff9900"
                            >
                            </el-rate>
                            <div style="color: rgb(247, 186, 42)">{{ scope.row.rating }}</div>
                        </div>
                        <div style="font-size: 12px; font-weight: 600;">价格:{{ scope.row.keepa_price }}</div>
                        <div style="font-size: 12px; font-weight: 600;">
                            更新时间：{{ scope.row.last_keepa_update_time }}
                        </div>
                        <div style="font-size: 12px; font-weight: 600;">品牌：{{ scope.row.brand }}</div>
                        <div style="font-size: 12px; font-weight: 600;">评论数：{{ scope.row.rating_count }}</div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="利润" min-width="180" align="center">
                <template slot-scope="scope">
                    <div @click="previewProfit(scope.row)" class="zoom">
                        利润：{{ scope.row.profit }} <br/>
                        利润率：{{scope.row['profit_rate'] ? accMul(scope.row['profit_rate'], 100) + '%' : '-' }}<br/>
                        投资回报率： {{scope.row['investment_return_rate'] ? accMul(scope.row['investment_return_rate'], 100) + '%' : '-' }}<br/>
                        0利润价格：{{scope.row['seller_price_no_profit']}}<br/>
                        配送费：{{scope.row['delivery_charge']}}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="毛利润" min-width="220" align="center">
                <template slot-scope="scope">
                    <div>
                        7日毛利润：{{ scope.row.gross_profit_7_days }} <br/>
                        <div class="smallTxt">{{ sevenDaysRange }}</div>

                        14日毛利润：{{ scope.row.gross_profit_14_days }} <br/>
                        <div class="smallTxt">{{ fourteenDaysRange }}</div>

                        30日毛利润：{{ scope.row.gross_profit_30_days }}
                        <div class="smallTxt">{{ thirtyDaysRange }}</div>

                    </div>
                </template>
            </el-table-column>

            <el-table-column label="销量" min-width="220" align="center">
                <template slot-scope="scope">
                    <div>
                        7日销量：{{ scope.row.sales_7_days }} <br/>
                        <div class="smallTxt">{{ sevenDaysRange }}</div>

                        14日销量：{{ scope.row.sales_14_days }} <br/>
                        <div class="smallTxt">{{ fourteenDaysRange }}</div>

                        30日销量：{{ scope.row.sales_30_days }}
                        <div class="smallTxt">{{ thirtyDaysRange }}</div>

                    </div>
                </template>
            </el-table-column>

            <el-table-column label="花费(¥)-广告销量(广告Acos)" min-width="320" align="center">
                <template slot-scope="scope">
                    <div>
                        7日花费：{{ scope.row.spend_7_days }} - {{ scope.row.ad_volume_7_days }}
                        <span v-if="scope.row['acos_7_days']">({{ accMul(scope.row['acos_7_days'], 100) + '%' }})</span>
                        <br/>
                        <div class="smallTxt">{{ sevenDaysRange }}</div>
                        14日花费：{{ scope.row.spend_14_days }} - {{ scope.row.ad_volume_14_days }}
                        <span
                            v-if="scope.row['acos_14_days']">({{ accMul(scope.row['acos_14_days'], 100) + '%' }})</span>
                        <br/>
                        <div class="smallTxt">{{ fourteenDaysRange }}</div>
                        30日花费：{{ scope.row.spend_30_days }} - {{ scope.row.ad_volume_30_days }}
                        <span
                            v-if="scope.row['acos_30_days']">({{ accMul(scope.row['acos_30_days'], 100) + '%' }})</span>
                        <br/>
                        <div class="smallTxt">{{ thirtyDaysRange }}</div>
                    </div>
                </template>
            </el-table-column>


            <el-table-column label="Teambition" width="150" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.tfs_name" style="color:green;font-weight:900;letter-spacing: 2px;">
                        {{ scope.row.tfs_name }}
                    </div>
                    <div v-if="scope.row.teambition_url" @click="jumpUrl(scope.row.teambition_url)"
                         style="color:blue;cursor: pointer;">任务详情
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="核对信息" width="400" align="center">
                <template slot-scope="scope">
                    <div style="text-align: left">
                        <div style="font-size: 12px; font-weight: 600;">标品类型:{{ scope.row.standard_product_type }}</div>
                        <div style="font-size: 12px; font-weight: 600;">fba费用核对:
                            <span
                                :class="{'redClass': scope.row.check_fba_charge == -1, 'greenClass': scope.row.check_fba_charge == 1}">
                                {{
                                    scope.row.check_fba_charge == 1 ? '已核对' : scope.row.check_fba_charge == 0 ? '待核对' : '核对有误'
                                }}
                            </span>
                        </div>
                        <div style="font-size: 12px; font-weight: 600;">是否主卖: {{ scope.row.is_main_seller ? '是' : '否' }}</div>
                        <div style="font-size: 12px; font-weight: 600;">包装核对: {{ scope.row.check_packing ? '是' : '否' }}</div>
                        <div style="font-size: 12px; font-weight: 600;">价格核对: {{ scope.row.check_price ? '是' : '否' }}</div>
<!--                        <div style="font-size: 12px; font-weight: 600;">Vine情况: {{ scope.row.vine_status }}</div>-->
<!--                        <div style="font-size: 12px; font-weight: 600;">Vine店铺: {{ scope.row.vine_shop }}</div>-->
                        <div style="font-size: 12px; font-weight: 600;">是否季节性: {{ scope.row.is_seasonality == 1 ? '是' : '否' }}</div>
                        <div style="font-size: 12px; font-weight: 600;">季节: {{ scope.row.season }}</div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="广告情况" width="220" align="center">
                <template slot-scope="scope">
                    <div>
                        <div class="basicInfo">店铺：{{ scope.row.ad_shopname }}</div>
                        <div class="basicInfo">Asin：{{ scope.row.ad_asin }}</div>
                        <div class="basicInfo">MSKU：{{ scope.row.ad_msku }}</div>
                        <div class="basicInfo">品名：{{ scope.row.ad_product_name }}</div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="已开广告组" align="center" :show-overflow-tooltip="true" width="130">
                <template slot-scope="scope">
                    <span :class="{'hasStyle': (scope.row.had_ads || []).length > 0}"
                          @click="openListModal(scope.row.had_ads)">{{ (scope.row.had_ads || []).length }}</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="370" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click="updateFunc(scope.row)">
                        核对
                    </el-button>

                    <el-button style="margin: 5px 0 5px 10px" size="mini"
                               @click="seeDetail(scope.row)">详情</el-button>

                    <el-button style="margin: 5px 0 5px 10px" type="warning" size="mini"
                               @click="showInner(2, scope.row)">
                        修改asin
                    </el-button>

                    <el-button style="margin: 5px 0 5px 10px" type="danger" size="mini"
                               @click="noActiveList(scope.row)">
                        不再运营
                    </el-button>

<!--                    <el-button type="primary" size="mini" @click="otherNationCreate(scope.row)">-->
<!--                        他国创建-->
<!--                    </el-button>-->
                </template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :page-size="query.limit" :current-page="query.page"
                       :page-sizes="[20, 50, 100]" :total="query.total" background
                       style="float: right;margin-top: 10px;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>
        <item-info ref="itemInfo" @close-callback="closeCllback"></item-info>
        <uploadDom :visible="addSubLibraryModal" @close-callback="closeCllback"
                   title="上传"/>
        <car-modal ref="card" @close-callback="closeCllback"></car-modal>
        <fba-modal ref="fbaModal" @close-callback="closeCllback"></fba-modal>
        <open-list-modal ref="openListModal"></open-list-modal>
        <autoOptimizeDialog
            ref="autoOptimizeRef"
            :visible="ctrl.autoOptimizeVisible"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback"
        ></autoOptimizeDialog>
        <el-dialog
            title="提示" :visible.sync="noDialogVisible" width="30%" :before-close="noHandleCloseModal"
            append-to-body>
            <span style="margin-bottom: 20px">确认不再运营吗？</span>

            <el-form>
                <el-form-item label="不再运营原因:" class="query-form-item">
                    <el-input style="width: 170px;" clearable v-model="fail_reason" placeholder="请输入不再运营原因"
                              size="mini"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="noHandleCloseModal" size="mini">取 消</el-button>
                <el-button type="primary" @click="noOfficialOperation" size="mini">确 定</el-button>
              </span>
        </el-dialog>

        <el-dialog
            width="30%"
            title="修改运营ASIN"
            :visible.sync="innerModal.visible"
            :before-close="closeInner"
            append-to-body>
            <el-form ref="formData" :model="query" :inline="true" size="mini">
                <el-form-item label="运营ASIN:" class="query-form-item" prop="operator_asin">
                    <el-input style="width: 150px;" clearable v-model="operator_asin" placeholder="请输入运营ASIN"
                              size="mini"></el-input>
                </el-form-item>
            </el-form>

            <el-row style="margin-top:17px; ">
                <el-button style="float:right;margin-left:6px;" size="mini" type="primary" plain
                           v-show="innerModal.type===2" @click="updateAsinFunc()" :loading="updateAsinLoading">修 改
                </el-button>
            </el-row>
        </el-dialog>
        <updateAcosDom ref="updateAcosRef" @close-callback="closeCllback"></updateAcosDom>
        <updateSkagDom ref="updateSkagRef" @close-callback="closeCllback"/>
        <otherNation ref="otherNationModal" @close-callback="closeCllback"></otherNation>
        <detail-preview ref="detailPreview"></detail-preview>
        <child-info-modal :visible="ctrl.childInfoVisible" :info="childInfo"
                          @close-callback="closeCllback"></child-info-modal>
    </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {downloadFileUrl} from '@/utils/method'
import ItemInfo from './depend/itemInfo'
import uploadDom from './depend/upload'
import carModal from './depend/carModal'
import fbaModal from './depend/fbaModal'
import openListModal from './depend/openListModal'
import updateAcosDom from './depend/updateAcos'
import updateSkagDom from './depend/updateSkag'
import autoOptimizeDialog from './depend/autoOptimizeDialog.vue'
import otherNation from './depend/otherNation.vue'
import RealTimeQueryTemplate from '@/views/lowPriceMall/realTime/depend/realtimeQueryTemplate.vue'
import DetailPreview from '../lowPriceRealtimeDetail.vue'
import ChildInfoModal from './depend/childInfoModal.vue'


export default {
    components: {
        ChildInfoModal,
        DetailPreview,
        RealTimeQueryTemplate,
        otherNation,
        autoOptimizeDialog,
        ItemInfo,
        uploadDom,
        carModal,
        fbaModal,
        openListModal,
        updateAcosDom,
        updateSkagDom
    },
    data() {
        return {
            sevenDaysRange: '',
            fourteenDaysRange: '',
            thirtyDaysRange: '',
            childInfo: {},
            rules: {
                operator_asin: [{required: true, message: '请输入运营ASIN', trigger: 'blur'},]
            },
            innerModal: {
                visible: false,
                selInfo: {},
                type: 1,
            },
            fail_reason: '',
            tempDate: {},
            noDialogVisible: false,
            updateAsinLoading: false,

            recheckLoading: false,
            vineStatusArr: [
                {name: '全部', value: ''},
                {name: '未申请', value: '未申请'},
                {name: '申请中', value: '申请中'},
                {name: '完成', value: '完成'},
                {name: '老品', value: '老品'},
            ],
            standardProductTypeArr: [
                {name: '全部', value: ''},
                {name: '未录入', value: -1},
                {name: '标品-大众', value: '标品-大众'},
                {name: '标品-小众', value: '标品-小众'},
                {name: '非标-大众', value: '非标-大众'},
                {name: '非标-小众', value: '非标-小众'},
            ],
            fbaCollateArr: [
                {name: '全部', value: ''},
                {name: '待核对', value: 0},
                {name: '已核对', value: 1},
                {name: '核对有误', value: -1},
            ],
            collateArr: [
                {name: '全部', value: ''},
                {name: '已核对', value: 1},
                {name: '未核对', value: 0},
            ],
            isLowPrice: [
                {name: '全部', value: ''},
                {name: '未核对', value: -1},
                {name: '是', value: 1},
                {name: '否', value: 0},
            ],
            addSubLibraryModal: false,

            editType: 0,
            manualRootShow: false,
            tableHeight: null,
            managerAnalysisList: [],
            teambitionList: {},

            operator_asin: '',
            query: {
                page: 1,
                limit: 20,
                total: 0,
            },

            list: [],
            disabled: false,
            loading: false,
            ctrl: {
                dialogTitle: '',
                autoOptimizeVisible: false,
                childInfoVisible: false,
            },
        }
    },
    created() {
        this.getManagerAnalysisList()
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
        this.getList()
        this.setDateRanges()
        this.getTeambitionList()
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val
        }
    },
    methods: {
        setDateRanges() {
            const today = new Date()
            const yesterday = new Date(today)
            yesterday.setDate(today.getDate() - 1) // 昨天的日期

            // 7日内
            const sevenDaysAgo = new Date(yesterday)
            sevenDaysAgo.setDate(yesterday.getDate() - 6) // 7天前的日期

            // 14日内
            const fourteenDaysAgo = new Date(yesterday)
            fourteenDaysAgo.setDate(yesterday.getDate() - 13) // 14天前的日期

            // 30日内
            const thirtyDaysAgo = new Date(yesterday)
            thirtyDaysAgo.setDate(yesterday.getDate() - 29) // 30天前的日期

            // 格式化并赋值给data
            this.sevenDaysRange = `${this.formatDate(sevenDaysAgo)} - ${this.formatDate(yesterday)}`
            this.fourteenDaysRange = `${this.formatDate(fourteenDaysAgo)} - ${this.formatDate(yesterday)}`
            this.thirtyDaysRange = `${this.formatDate(thirtyDaysAgo)} - ${this.formatDate(yesterday)}`
        },
        formatDate(date) {
            return date.toISOString().split('T')[0] // 格式化日期为 "YYYY-MM-DD"
        },
        getTeambitionList() {
            api.get_tfs_name_lists().then((res) => {
                if (res.success) {
                    this.teambitionList = res.data
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            })
        },
        adjustNumber(num) {
            // 获取整数部分
            let integerPart = Math.floor(num);
            // 使用toFixed(1)来获取一位小数，并转换为数字以避免精度问题
            let decimalPart = Number(((num - integerPart).toFixed(1)));
            if (decimalPart >= 0 && decimalPart < 0.3) {
                return integerPart
            } else if (decimalPart >= 0.3 && decimalPart < 0.8) {
                return integerPart + 0.5
            } else if (decimalPart >= 0.8 && decimalPart < 1) {
                return integerPart + 1
            } else {
                // 如果小数部分不在上述范围内，返回原数字
                return num
            }
        },
        //Auto优化
        autoOptimize() {
            this.ctrl.dialogTitle = 'Acos优化'
            this.ctrl.autoOptimizeVisible = true
            this.$refs.autoOptimizeRef.getList()
        },
        resetFirstTime(data) {
            this.$confirm('是否重置时间?', '提示', {type: 'warning'}).then(() => {
                api.operating_asin_manager_index_update_field({
                    id: data.id,
                    fba_first_sale_time: 'reset'
                }).then((res) => {
                    if (res.success) {
                        this.$message.success('重置成功')
                        this.getList()
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                })
            })
        },
        updateAcos(data) {
            this.$refs.updateAcosRef.openModal(data)
        },
        updateSkag(data) {
            this.$refs.updateSkagRef.openModal(data)
        },
        exportFunc() {
            api.operating_asin_manager_index_export_operating_asin_list().then((res) => {
                if (res.success) {
                    this.downFile(res.data)
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            })
        },
        openListModal(data) {
            if ((data || []).length > 0) {
                this.$refs.openListModal.openModal(data)
            }
        },
        updateAsinFunc() {
            this.updateAsinLoading = true
            api.low_price_mall_operating_update_operating_asin({
                id: this.innerModal.selInfo.id,
                asin: this.operator_asin
            }).then(res => {
                if (res.code === 0) {
                    this.$message({message: '修改成功', type: 'success'})
                    this.closeInner()
                    this.getList()
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.updateAsinLoading = false
            })
        },
        noOfficialOperation() {
            let func = () => {
                api.low_price_mall_operating_update_operating_asin_to_no_use({
                    id: this.tempDate.id,
                    fail_reason: this.fail_reason
                }).then((res) => {
                    if (res.success) {
                        this.$message.success('操作成功')
                        this.fail_reason = ''
                        this.noDialogVisible = false
                        this.getList()
                    } else {
                        this.$message.error(res.message)
                    }
                }).catch(() => {
                    this.noDialogVisible = false
                })
            }
            func()
        },
        noHandleCloseModal() {
            this.fail_reason = ''
            this.noDialogVisible = false
        },
        showInner(typeNum, selInfo) {
            this.innerModal.type = typeNum
            this.innerModal.visible = true
            if (typeNum == 2) {
                const info = JSON.parse(JSON.stringify(selInfo))
                this.operator_asin = info.asin
                this.innerModal.selInfo = info
            }
        },
        closeInner() {
            this.innerModal.visible = false
            this.operator_asin = ''
            this.query.status = 1
        },
        noActiveList(data) {
            this.tempDate = data
            this.noDialogVisible = true
        },
        otherNationCreate(data){
            this.$refs.otherNationModal.openModal(data)
        },
        recheck(data) {
            this.recheckLoading = true
            api.operating_asin_manager_index_recalibrate_fba_charge({id: data.id}).then(res => {
                if (res.success) {
                    this.$message.success('核对成功')
                    this.getList()
                } else {
                    this.$notify({title: '提示', message: res.message, duration: 5000})
                }
            }).finally(() => {
                this.recheckLoading = false
            })
        },
        showFbaModal(arr) {
            if (arr.length > 0) {
                this.$refs.fbaModal.showModal(arr)
            }
        },
        previewProfit(data) {
            let resData = JSON.parse(JSON.stringify(data))
            resData.refund_rate = this.accMul(resData.refund_rate, 100)
            this.$refs.card.showModal(resData, JSON.parse(JSON.stringify(data)), 0)

            // api.operating_asin_manager_index_get_cost_analysis_data({id: data.id}).then(res => {
            //     if (res.success) {
            //         let resData = res.data
            //         resData.refund_rate = resData.refund_rate * 100
            //         this.$refs.card.showModal(resData, JSON.parse(JSON.stringify(data)))
            //     } else {
            //         this.$message({type: 'error', message: res.message})
            //     }
            // })
        },
        getManagerAnalysisList() {
            api.manager_index_get_operator_list().then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.managerAnalysisList = responseList
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        uploadFunc() {
            this.addSubLibraryModal = true
        },
        closeCllback(refresh) {
            this.addSubLibraryModal = false
            this.ctrl.autoOptimizeVisible = false
            this.ctrl.childInfoVisible = false
            refresh == true && this.getList()
        },
        seeDetail(data) {
            this.$refs.detailPreview.visible = true
            this.$refs.detailPreview.title = '详情展示'
            this.$refs.detailPreview.formData = data
        },
        updateFunc(data) {
            console.log('data', data)
            this.$refs.itemInfo.openModal(3, JSON.parse(JSON.stringify(data || {})))
        },
        delete_records(data) {
            this.$confirm('确认删除该记录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                api.branch_warehouse_manager_delete({id: data.id}).then(() => {
                    this.$message.success('删除成功')
                    this.getList()
                })
            })
        },
        getUpdateStatus(data) {
            api.branch_warehouse_line_get_update_status({id: data.id}).then((res) => {
                const h = this.$createElement
                this.$notify({
                    title: '提示',
                    message: h('i', {style: 'color: teal'}, res.data || ''),
                    duration: 5000
                })
            }).catch(res => {
                this.$message({type: 'error', message: res.message})
            })
        },
        getPeaple_records(data) {
            this.subLibraryDetailInfo = data
            this.peopleListVisible = true
        },
        showErrorInfo(info) {
            this.errorInfoShow = true
            this.errorMsg = info.alibaba_err_msg
        },
        showManualRoot(info) {
            this.manualRootShow = true
            this.manualRootList = info
        },
        getList() {
            this.loading = true
            const tempQuery = this.$refs.realTimeQueryRef.handleQueryData()
            api.low_price_mall_operating_operating_asin_list(tempQuery).then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.list = (res.data.list || []).map(item => {
                        let maxSale = ''
                        let maxTransit = ''
                        item.fba_datas = JSON.parse(item.fba_datas || '[]')
                        if (item.fba_datas && item.fba_datas.length > 0) {
                            let sortSale = (item.fba_datas || []).sort((a, b) => b.fba_sale_quantity - a.fba_sale_quantity)
                            maxSale = sortSale[0].shopname
                            let sortTransit = (item.fba_datas || []).sort((a, b) => b.fba_transit_quantity - a.fba_transit_quantity)
                            maxTransit = sortTransit[0].shopname
                        }
                        item.maxSale = maxSale
                        item.maxTransit = maxTransit
                        item.ratingNum = this.adjustNumber(item.rating || 0)
                        return item
                    })
                    this.query.total = res.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        clickRowHandle(row, column) {
            console.log('column', column)
            let update = false

            if (['标题', '类目树', '子类目', '颜色', '备注'].includes(column.label)) {
                this.childInfo.title = column.label
                let info = row.title
                if (column.label == '类目树') {
                    info = row.category_tree
                } else if (column.label == '子类目') {
                    info = row.categories_str
                } else if (column.label == '颜色') {
                    info = row.color
                }else if (column.label == '备注') {
                    info = row.remark
                    update = true
                }
                this.childInfo.id = row.id
                this.childInfo.info = info
                this.childInfo.update = update
                this.ctrl.childInfoVisible = true
            }
            if (['折叠', '收起'].includes(column.label)) {
                this.isFold = !this.isFold
            }
        },
        clickHeaderHandle(row, column) {
            if (['折叠', '收起'].includes(row.label)) {
                this.isFold = !this.isFold
            }
        },
        handleSortChange(val) {
            if (val.order == 'ascending') {
                this.query.desc = 'desc'
                this.query.order = val.prop
            } else if (val.order == 'descending') {
                this.query.desc = 'asc'
                this.query.order = val.prop
            }
            this.getList()
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList()
            })
        },
        //重置
        onReset() {
            this.query = {
                state: '',
                asin: '',
                product_name: '',
                standard_product_type: '',
                check_fba_charge: '',
                check_packing: '',
                is_market_lowest_price: '',
                vine_status: '',
                operation_id: '',

                page: 1,
                limit: 20,
                total: 0,
            }
            this.getList()
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        basicData() {
            this.showBasicConfigDataModal = true
        },
        addParse() {
            this.showAddParseModal = true
        },
        // 批量删除
        batchDelete() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量删除已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_delete({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '删除成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 批量重置
        batchReset() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量重置已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_batch_reset({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '重置成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 类目列表
        categoryList() {
            this.showCategoryList = true
        },
        upadteRanking() {
            this.upadteRankingModal = true
        },
        change() {
            this.getList()
        },
        clearValue() {
            this.query.state = ''
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true
            this.$nextTick(() => {
                this.$refs[this.activeName].getList()
            })
        },
        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        // bid记录列表
        openBidList(data) {
            this.currentId = data.id
            this.ctrl.bidDialogVisible = true
        },
        async startDecode(row, force = 0) {
            if (force) {
                await this.$confirm('是否重新运行解析任务', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            }
            let list = JSON.parse(JSON.stringify(this.list))
            api.variety_cost_control_analysis_parsing_file({
                id: row.id,
                force
            }).then(() => {
                const index = list.findIndex(item => item.id === row.id)
                list[index].status = 1
                this.list = list
            })
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id
            this.ctrl.addPpcDialogVisible = true
        },
        goBackList() {
            this.showPageType = 0
        },
        update(data) {
            this.updateData = data
            this.showAddRecord = true
        }
    }
}
</script>

<style type="text/scss" lang="scss" scoped>

.hasStyle {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
}

.zoom {
    cursor: pointer; /* 改变鼠标指针为手指形状 */
}

.zoom:hover {
    cursor: zoom-in; /* 鼠标悬停时变成放大镜图标 */
}

.basicInfo {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 5px;
}

.redClass {
    color: red;
    font-weight: bold;
}

.greenClass {
    color: green;
    font-weight: bold;
}

.fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mini_div .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}

/deep/ .el-form-item {
    margin-bottom: 8px !important;
}
</style>
